import { render, staticRenderFns } from "./AlipayAccounts.vue?vue&type=template&id=18da72e9&scoped=true&"
import script from "./AlipayAccounts.vue?vue&type=script&lang=js&"
export * from "./AlipayAccounts.vue?vue&type=script&lang=js&"
import style0 from "./AlipayAccounts.vue?vue&type=style&index=0&id=18da72e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da72e9",
  null
  
)

export default component.exports